<header class="bg-header dark:bg-dark-header text-white shadow w-full dark:border-dark-header dark:border-b no-print">
  <div class="flex justify-between items-center h-[70px] px-4 w-full">
    <!-- Default/WARFIGHTERS theme -->


    <!-- PavCon theme -->
    <div class="flex flex-shrink-0 flex-row gap-1 rounded-md border-gray-50 relative -ml-4 pl-4 h-[72px]"
      *ngIf="currentTheme === 'onix'">
      <div class="absolute inset-y-0 left-0 w-[200px] bg-gradient-to-r from-white/95 via-white/50 to-transparent"></div>
      <div class="relative z-10">
        <img class="h-12 mt-4" alt="PavCon" src="./../../../assets/logos/pavcon.png" (click)="goHome()" priority />
      </div>
      <div class="title-container relative z-10 " style="margin-top: -10px;" (click)="goHome()">
        <span class="text-lg text-white font-bold">Data Capture</span>
        <div class="flex flex-row gap-1 items-start">
          <span class="sub-title text-white font-medium">Platform</span>
          <span class="text-gray-900 text-xs">{{ version }}</span>
        </div>
      </div>
    </div>





    <!-- SAFiRE theme -->
    <div class="flex flex-shrink-0 flex-row gap-1 rounded-md border-gray-50 relative -ml-4 pl-4 h-[72px]"
      *ngIf="currentTheme === 'EMiRLD'">
      <div class="absolute inset-y-0 left-0 w-[200px] bg-gradient-to-r from-white/95 via-white/50 to-transparent"></div>
      <div class="relative z-10">
        <img class="h-16 mt-0" alt="emirld" src="./../../../assets/logos/emirld.png" (click)="goHome()" priority />
      </div>
      <div class="title-container relative z-10" (click)="goHome()">
      </div>
    </div>
    <!-- <div class="flex flex-shrink-0 flex-row gap-1 rounded-md border-gray-50" *ngIf="currentTheme === 'SAFiRE'">
      <img class="h-16 mt-0 shadow-lg" alt="SAFiRE" src="./../../../assets/logos/safire.png" (click)="goHome()"
        priority />
      <div class="title-container" (click)="goHome()">
        <span class="text-lg text-white font-bold">SAFiRE</span>
        <div class="flex flex-row gap-1 items-start">

          <span class="text-gray-200 text-xs">{{ version }}</span>
        </div>
      </div>
    </div> -->

    <div class="ml-4 flex flex-row items-end gap-3 md:ml-6 pb-[8px]">




      <div class="relative">


        <button [attr.aria-expanded]="userMenuOpen" aria-haspopup="true" (click)="toggleUserMenu()"
          class="flex items-center justify-between w-full h-[50px] px-3 py-1 space-x-3 text-left transition-colors duration-200 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800  bg-background-alt">
          <div class="flex items-center space-x-3">
            <div class="flex-shrink-0">
              <div class="w-8 h-8 bg-black rounded-full flex items-center justify-center">
                <span class="text-lg font-bold text-white">{{ getUserInitials() }}</span>
              </div>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                {{ currentUser.name || '' }} {{ currentUser.lastName || '' }}
              </p>
              <p class="text-xs text-gray-900 dark:text-gray-400 truncate">
                {{ currentUser.email || '' }}
              </p>
            </div>
          </div>
          <lucide-icon name="chevron-down" [ngClass]="{'rotate-180': userMenuOpen}"
            class="w-5 h-5 text-black transition-transform duration-200"></lucide-icon>
        </button>

        <div *ngIf="userMenuOpen" class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white focus:outline-none"
          role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1"
          style="z-index: 1000 !important;">
          <div class="py-1" role="none">
            <button (click)="goToApplicationsLauncher()"
              class="w-full text-left text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
              role="menuitem" tabindex="-1" id="user-menu-item-0">
              <lucide-icon name="layout-grid" class="w-5 h-5 mr-2 text-blue-500"></lucide-icon>
              Return to Apps Launcher
            </button>
            <div class="border-t border-gray-200 my-1"></div>
            <button (click)="logout()"
              class="w-full text-left text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 flex items-center"
              role="menuitem" tabindex="-1" id="user-menu-item-1">
              <lucide-icon name="log-out" class="w-5 h-5 mr-2 text-red-500"></lucide-icon>
              Logout
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</header>